import { gql } from '@apollo/client';

export const USERS = gql`
  query Users($page: Int, $pageSize: Int, $search: String, $role: String) {
    users(page: $page, pageSize: $pageSize, search: $search, role: $role) {
      items {
        id
        isVerified
        name
        email
        roles
      }
      totalCount
    }
  }
`;

export const USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      isVerified
      name
      email
      roles
      createdAt
      contractor {
        id
        name
        phone
        email
        description
        availableArea {
          states
          counties
        }
        createdAt
        updatedAt
      }
    }
  }
`;
